import { gql } from "@apollo/client";

const GET_SUSPENSIONES = gql`
    query suspencionesByIdEvaluacion( $idEvaluacion: Int!){
        suspencionesByIdEvaluacion( idEvaluacion: $idEvaluacion){
            idSuspension
            idEvaluacion
            idPaciente
            idSuspensionMotivo
            observaciones
            fechaDesde
            fechaHasta
            fechaAlta
            fechaObito
            detalleObito
            motivoDescripcion
            usuario
        }
    }
`;

export default GET_SUSPENSIONES;

const adaptSuspension = (suspension) => {
  return {
    idSuspension: suspension?.idSuspension,
    idEvaluacion: suspension?.idEvaluacion,
    idPaciente: suspension?.idPaciente,
    idSuspensionMotivo: suspension?.idSuspensionMotivo,
    observaciones: suspension?.observaciones,
    fechaDesde: suspension?.fechaDesde,
    fechaHasta: suspension?.fechaHasta,
    fechaAlta: suspension?.fechaAlta,
    fechaObito: suspension?.fechaObito,
    detalleObito: suspension?.detalleObito,
    motivoDescripcion: suspension?.motivoDescripcion,
    usuario: suspension?.usuario
  };
};

export const adaptSuspensionesArray = (suspensiones) => {
  return structuredClone(suspensiones)?.
  map((suspension) => adaptSuspension(suspension));
};